/**
 * Propriétés pour les actions en cas de non réponse (sur une flèche de type "par défaut"après une Tache)
 * Cela va être enregistré dans le BPMN sous la forme :
 * <bpmn:sequenceFlow id="a" sourceRef="b" targetRef="c" 
 *  aktor:delay="P2DT3H" />
 * 
 * aktor:delay :
 * - la durée de la pause en ISO 8601. Exemple : P2DT3H (2 jours et 3 heures)
 * - si la valeur est vide, on considère que la pause est de 1 jour (P1D)
 * 
 */
import { html } from 'htm/preact';
import { NumberFieldEntry, isNumberFieldEntryEdited } from '@bpmn-io/properties-panel';
import { useService } from 'bpmn-js-properties-panel';
import { parse as parseDuration, toString as toISODuration } from 'duration-fns';

function DefaultFlowProps(element) {
  // console.log(element);
  return [{
    id: 'days',
    element,
    component: DaysField,
    isEdited: isNumberFieldEntryEdited
  }, {
    id: 'hours',
    element,
    component: HoursField,
    isEdited: isNumberFieldEntryEdited
  }, {
    id: 'minutes',
    element,
    component: MinutesField,
    isEdited: isNumberFieldEntryEdited
  }, {
    id: 'seconds',
    element,
    component: SecondsField,
    isEdited: isNumberFieldEntryEdited
  }];
}

function getDelay(element, unit) {
  const delay = element.businessObject['delay'] || 'P1D';
  const duration = parseDuration(delay);
  return duration[unit]?.toString() || '0';
}

function setDelay(element, modeling, unit, value) {
  const currentDelay = element.businessObject['delay'] || 'P1D';
  const duration = parseDuration(currentDelay);
  duration[unit] = parseInt(value) || 0;
  
  const newDelay = toISODuration(duration);
  return modeling.updateProperties(element, { delay: newDelay });
}

function DaysField({ element, id }) {
  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  return html`
    <div class="inline-field">
      <${NumberFieldEntry}
        id=${id}
        element=${element}
        label=${translate('days')}
        getValue=${() => getDelay(element, 'days')}
        setValue=${value => setDelay(element, modeling, 'days', value)}
        debounce=${debounce}
        min=0
        max=9999
        step=1
      />
    </div>
  `;
}

function HoursField({ element, id }) {
  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');
  
  return html`
    <div class="inline-field">
      <${NumberFieldEntry}
        id=${id}
        element=${element}
        label=${translate('hours')}
        getValue=${() => getDelay(element, 'hours')}
        setValue=${value => setDelay(element, modeling, 'hours', value)}
        debounce=${debounce}
        min=0
        max=23
        step=1
      />
    </div>
  `;
}

function MinutesField({ element, id }) {
  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  return html`
    <div class="inline-field">
      <${NumberFieldEntry}
      id=${id}
      element=${element}
      label=${translate('minutes')}
      getValue=${() => getDelay(element, 'minutes')}
      setValue=${value => setDelay(element, modeling, 'minutes', value)}
      debounce=${debounce}
      min=0
      max=59
      step=1
    />
  </div>
`;
}

function SecondsField({ element, id }) {
  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  return html`
    <div class="inline-field">
      <${NumberFieldEntry}
        id=${id}
        element=${element}
        label=${translate('seconds')}
        getValue=${() => getDelay(element, 'seconds')}
        setValue=${value => setDelay(element, modeling, 'seconds', value)}
        debounce=${debounce}
        min=0
        max=59
        step=1
      />
    </div>
  `;
}


export default DefaultFlowProps;
